import React, { FunctionComponent } from "react";
import { UIConfigurationContext } from "../../common/contexts/ui-configurationContext";
import { Facilitator } from "../facilitator";
import { Card, CardContent, Grid } from "@mui/material";

import { FormType, withForm } from "../../common/ui-form";
import { SchoolFieldSet } from "./SchoolFieldSet";
import { ISchoolModel } from "../models/ISchoolModel";
import { getFacilitatorSchoolControlState } from "./facilitatorSchoolControlState";
import { getFacilitatorSchoolFormValidations } from "./facilitatorSchoolValidations";

const FacilitatorAddSchoolForm = withForm<
    ISchoolModel,
    FormType<ISchoolModel>
>(SchoolFieldSet);


export const FacilitatorAddSchool: FunctionComponent = () => {
    const uiConfigData = React.useContext(UIConfigurationContext);
    const intialValues = (): ISchoolModel => {
        return {
            state: '',
            address: '',
            userId: 0,
            schoolName: '',
            email: '',
            userName: '',
            password: '',
            mobileNumber: '',
            foundationPrograms: [],
            olympiadExams: [],
            chairmanName: '',
            chairmanWhatsAppContact: '',
            principalName: '',
            principalWhatsAppContact: '',
            programInChargeName: '',
            programInchargeWhatsAppContact: '',
            abhyasaBharathiMagazineAccess: false,
            videoLessionPrograms: []
        };
    };


    return (
        <Facilitator>
            <Grid container>
                <Grid item xs={12}>
                    <Card sx={{ height: "100%" }}>
                        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                            <FacilitatorAddSchoolForm
                                enableReintialize
                                formValues={intialValues()}
                                pageTitle="Add New School"
                                pageSubtitle="Create a new school account and configure program access"
                                getValidationSchema={(v: ISchoolModel) =>
                                    getFacilitatorSchoolFormValidations(v)
                                }
                                getControlState={(v: ISchoolModel) =>
                                    getFacilitatorSchoolControlState(v)
                                }
            />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Facilitator>);
}